const initialState = {
  contentApi: process.env.CLIENT_CONTENT_API_URL,
  eveApi: process.env.CLIENT_EVE_API_URL,
};

const config = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default config;
